import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../utility';

const initialState = {
    mobileHome: true,
    breakupExpanded: 0,
    isBreakupTwoExpanded: false,
    isBreakupThreeExpanded: false,
    mobileFiltersToggle: false,
    mobileFareBreakup: false,
    mobileReviewsToggle: false,
    mobileBookingEngine: false,
    tabletBookingEngine: true,
    travellerList: false,
    closeBookingEngineButton: false,
    returnFlights: false,
    isInsuranceExpanded: false,
    isGstExpanded: false,
    addonsView: null,
    addonsExpanded: false,
    headerView: 'calendar',
    fullCalendar: false,
    rtDepart: false,
    rtReturn: false,
    resetArticle: false,
    dropDownIndex: false,
    userImages: [],
    isLayoverExpanded: false,
    paymentMode: 'cp',
    bankOption: '',
    bankCode: '',
    walletOption: '',
    mobileFlightDetail: false,
    slideCounter: 0,
    desktopFilters: false,
    hideFareAlert: false,
    showAgentProfit: false,
    roundTripFareRules: false,
    recentBookingType: 1,
    paymentOptionsMobile: false,
    detailsView: 'details'
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SHOW_MOBILE_HOME:
            return updateObject(state, {mobileHome: true})
        case actionTypes.HIDE_MOBILE_HOME:
            return updateObject(state, {mobileHome: false})
        case actionTypes.TOGGLE_FARE_BREAKUPS:
            let breakupValue = action.val;
            if (breakupValue === state.breakupExpanded) {
                breakupValue = 0;
            } else breakupValue = action.val;
            return updateObject(state, { breakupExpanded: breakupValue })
        case actionTypes.TOGGLE_MOBILE_FILTERS:
            return updateObject(state, {mobileFiltersToggle: !state.mobileFiltersToggle})
        case actionTypes.TOGGLE_MOBILE_FARE_BREAKUP:
            return updateObject(state, {mobileFareBreakup: !state.mobileFareBreakup})
        case actionTypes.TOGGLE_MOBILE_REVIEWS:
            return updateObject(state, {mobileReviewsToggle: !state.mobileReviewsToggle})
        case actionTypes.SHOW_MOBILE_BOOKING_ENGINE:
            return updateObject(state, {mobileBookingEngine: true})
        case actionTypes.HIDE_MOBILE_BOOKING_ENGINE:
            return updateObject(state, {mobileBookingEngine: false})
        case actionTypes.TOGGLE_MOBILE_BOOKING_ENGINE:
            return updateObject(state, {mobileBookingEngine: !state.mobileBookingEngine})
        case actionTypes.TOGGLE_TABLET_BOOKING_ENGINE:
            return updateObject(state, {tabletBookingEngine: !state.tabletBookingEngine});
        case actionTypes.SHOW_TABLET_BOOKING_ENGINE:
            return updateObject(state, {tabletBookingEngine: true})
        case actionTypes.HIDE_TABLET_BOOKING_ENGINE:
            return updateObject(state, {tabletBookingEngine: false})
        case actionTypes.SHOW_MOBILE_CLOSE_BOOKING_ENGINE_BUTTON:
            return updateObject(state, {closeBookingEngineButton: true})
        case actionTypes.SHOW_RETURN_FLIGHTS:
            return updateObject(state, {returnFlights: true})
        case actionTypes.HIDE_RETURN_FLIGHTS:
            return updateObject(state, {returnFlights: false});
        case actionTypes.TOGGLE_INSURANCE:
            return updateObject(state, {isInsuranceExpanded: !state.isInsuranceExpanded})
        case actionTypes.TOGGLE_GST:
            return updateObject(state, {isGstExpanded: !state.isGstExpanded})
        case actionTypes.CLOSE_GST:
            return updateObject(state, {isGstExpanded: false})
        case actionTypes.TOGGLE_ADDONS:
            let addonsExpanded = true;
            if (action.val === state.addonsView) { addonsExpanded = !state.addonsExpanded }
            return updateObject(state, {addonsView: action.val, addonsExpanded: addonsExpanded})
        case actionTypes.SWITCH_HEADER_VIEW:
            return updateObject(state, {headerView: action.val});
        case actionTypes.TOGGLE_FULL_CALENDAR:
            return updateObject(state, {fullCalendar: !state.fullCalendar});
        case actionTypes.CLOSE_FULL_CALENDAR:
            return updateObject(state, {fullCalendar: false});
        case actionTypes.TOGGLE_RT_DEPART:
            return updateObject(state, {rtDepart: !state.rtDepart});
        case actionTypes.TOGGLE_RT_RETURN:
            return updateObject(state, {rtReturn: !state.rtReturn});
        case actionTypes.CLOSE_RT_DEPART:
            return updateObject(state, {rtDepart: false});
        case actionTypes.CLOSE_RT_RETURN:
            return updateObject(state, {rtReturn: false});
        case actionTypes.OPEN_DROPDOWN:
            return updateObject(state, {dropDownIndex: action.id});
        case actionTypes.CLOSE_DROPDOWN:
            return updateObject(state, {dropDownIndex: -1});
        case actionTypes.USER_IMAGE_UPLOAD:
            return updateObject(state, {userImages: [
                ...state.userImages, {
                    file: action.file,
                    imagePreviewUrl: action.url,
                    userId: action.id
                }
            ]})
        case actionTypes.SET_PAYMENT_MODE:
            return updateObject(state, {paymentMode: action.val})
        case actionTypes.SET_BANK_OPTION:
            return updateObject(state, {bankOption: action.val, bankCode: action.code})
        case actionTypes.SET_WALLET_OPTION:
            return updateObject(state, {walletOption: action.val})
        case actionTypes.TOGGLE_MOBILE_FLIGHT_DETAIL:
            return updateObject(state, {mobileFlightDetail: !state.mobileFlightDetail})
        case actionTypes.ADDONS_EXPANDED:
            return updateObject(state, {addonsExpanded: !state.addonsExpanded})
        case actionTypes.RESET_ADDONS:
            return updateObject(state, {addonsExpanded: false})
        case actionTypes.SET_SLIDE_LEFT:
            if (state.slideCounter >= 0) return {...state};
            return updateObject(state, { slideCounter: state.slideCounter + 6 })
        case actionTypes.SET_SLIDE_RIGHT:
            if (state.slideCounter <= -6) return {...state};
            return updateObject(state, { slideCounter: state.slideCounter - 6 })
        case actionTypes.RESET_SLIDE_COUNTER:
            return updateObject(state, { slideCounter: 0 })
        case actionTypes.CLOSE_DESKTOP_FILTERS:
            return updateObject(state, { desktopFilters: false })
        case actionTypes.TOGGLE_DESKTOP_FILTERS:
            return updateObject(state, { desktopFilters: !state.desktopFilters })
        case actionTypes.HIDE_FARE_ALERT:
            return updateObject(state, {hideFareAlert: true})
        case actionTypes.TOGGLE_AGENT_PROFIT:
            return updateObject(state, { showAgentProfit: !state.showAgentProfit })
        case actionTypes.TOGGLE_ROUND_TRIP_FARE_RULES:
            return updateObject(state, { roundTripFareRules: !state.roundTripFareRules })
        case actionTypes.CLOSE_ROUND_TRIP_FARE_RULES:
            return updateObject(state, { roundTripFareRules: false })
        case actionTypes.TOGGLE_RECENT_BOOKING_TYPE:
            return updateObject(state, { recentBookingType: action.val })
        case actionTypes.TOGGLE_PAYMENT_OPTIONS_MOBILE:
            return updateObject(state, { paymentOptionsMobile: action.val })
        case actionTypes.TOGGLE_DETAILS_VIEW:
            return updateObject(state, { detailsView: action.view })
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/ui.js